import React from 'react';
import { Card, CardContent, Typography, TextField, Box, FormControlLabel, Switch } from '@mui/material';
import type { ExamData } from '@app-types/visit';
import { Assignment } from '@mui/icons-material';

interface ExamCardProps {
  exam: ExamData;
  onChange: (exam: ExamData) => void;
  disabled?: boolean;
}

const ExamCard: React.FC<ExamCardProps> = React.memo(({ exam, onChange, disabled = false }) => {
  const updateField = <K extends keyof ExamData>(field: K, value: ExamData[K]) => {
    onChange({ ...exam, [field]: value });
  };

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Assignment sx={{ mr: 1, color: 'secondary.main' }} />
          <Typography variant="h6">Examen clinic (SOAP)</Typography>
        </Box>
        
        <FormControlLabel
          control={
            <Switch
              checked={exam.allNormal === true}
              onChange={(e) => updateField('allNormal', e.target.checked)}
              disabled={disabled}
            />
          }
          label="Toate parametrii normali"
        />
        
        <TextField
          fullWidth
          multiline
          rows={6}
          label="Note examen fizic"
          value={exam.notes ?? ''}
          onChange={(e) => updateField('notes', e.target.value)}
          disabled={disabled}
          placeholder="Descriere examen fizic pe sisteme: respirator, cardiovascular, digestiv, nervos, musculo-scheletal, piele/par, ochi, urechi..."
          sx={{ mt: 2 }}
          helperText="Obligatoriu: completați fie 'Toate normale' fie notele detaliate"
        />
      </CardContent>
    </Card>
  );
});

ExamCard.displayName = 'ExamCard';

export default ExamCard;

